import { Link } from "@bond-london/gatsby-plugin-cms-i18next";
import classNames from "classnames";
import React from "react";
import { Trans } from "react-i18next";
import { DashedText } from "./DashedText";

export interface LinkInformation {
  title?: string | null;
  internal?: string | null;
  external?: string | null;
  showLinkAsButton?: boolean;
}

const LinkInside: React.FC<{
  title?: string | null;
  isButton?: boolean;
}> = ({ title, isButton }) => {
  return (
    <div className={classNames(isButton ? "servicesButton" : "read-more flex")}>
      <DashedText colorClassName={"text-hyacinth"}>
        {title ?? <Trans>Read more</Trans>}
      </DashedText>
    </div>
  );
};

const SingleLink: React.FC<{ link: LinkInformation }> = ({
  link: { title, internal, external, showLinkAsButton },
}) => {
  if (internal) {
    return (
      <Link to={internal}>
        <LinkInside title={title} isButton={showLinkAsButton} />
      </Link>
    );
  }
  if (external) {
    return (
      <a href={external} target="_blank" rel="noreferrer">
        <LinkInside title={title} />
      </a>
    );
  }
  return (
    <div>
      <LinkInside title={title} />
    </div>
  );
};

export const Links: React.FC<{
  links: Array<LinkInformation>;
  className?: string;
}> = ({ links, className }) => {
  return (
    <div className={classNames("flex flex-col gap-y-16px", className)}>
      {links.map((link) => (
        <SingleLink key={link.title} link={link} />
      ))}
    </div>
  );
};
